import { useTranslation } from '@dreamstack/i18n'
import React from 'react'
import type { FunctionComponent } from 'react'
import { SimpleMuiButton } from '../layout/SimpleMuiButton'
import { useIsReservationUi } from '../next/useIsReservationUi'

export const PropertyContactButton: FunctionComponent<React.PropsWithChildren<{
  onClick?: React.MouseEventHandler<HTMLElement> | undefined
}>> = ({ onClick }) => {
  const t = useTranslation()
  const isReservationUi = useIsReservationUi()
  if (isReservationUi) return null
  return (
    <div className="mt-px-16 md:-mt-px-16 ml:-mt-px-20">
      <SimpleMuiButton color="primary" variant="contained" onClick={onClick}>
        {t('accentro:contactform.contactUs')}
      </SimpleMuiButton>
    </div>
  )
}
